class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.init()
  }
  init() {
    const el = this.querySelector(".featured-collection-list");
    $(el).slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      speed: 1000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });
  }
}

window.customElements.define("featured-collection", FeaturedCollection);
